import { Box, Grid, Typography } from '@mui/material';
import { DateTime } from 'luxon';
import React from 'react';
import _ from 'lodash';
import { contentContainerProps, employeeHeaderSx, eventHeaderSx } from './employeesScheduleStyles';
import { humanizeDate } from '../../utility/dateUtils';
import { DAY_COUNT, datesHeaderContainerSx, datesHeaderGridSx, datesHeaderDateCellSx } from './employeesScheduleStyles';

const DatesHeader: React.FC<{ weekStart: DateTime }> = ({ weekStart }) => (
  <>
    <Grid size={1} sx={employeeHeaderSx}>
      <Typography>Employees</Typography>
    </Grid>

    <Grid {...contentContainerProps} sx={datesHeaderContainerSx}>
      <Box sx={eventHeaderSx}>
        <Typography fontWeight="500">Events</Typography>
      </Box>

      <Box sx={datesHeaderGridSx}>
        {_.map(_.range(0, DAY_COUNT), (dayDiff) => {
          const date = weekStart.plus({ day: dayDiff });

          return (
            <Box key={dayDiff} sx={datesHeaderDateCellSx}>
              <Typography variant="caption" title={humanizeDate(date.toISO())}>
                {`${date.weekdayShort}, ${date.day}`}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Grid>
  </>
);

export default DatesHeader;
